module.exports = __webpack_public_path__ + "img/06-targets.673d2d2f.svg";